<template>
  <layout-auth>
    <v-form>
      <v-container class="py-10">
        <v-row>
          <v-col>
            <h1 class="text-h4 font-weight-light py-5">
              {{ $t("accounts.confirmEditTitle") }}
            </h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2 class="text-h5 font-weight-light">
              {{ $t("accounts.accountDataSubtitle") }}
            </h2>
            <h3 class="text-subtitle-1 font-weight-medium">
              {{ $t("accounts.confirmAddSubtitle2") }}
            </h3>
          </v-col>
        </v-row>
        <v-row class="py-10">
          <v-col cols="12" sm="12" md="6" lg="4">
            <label class="second-type-label">{{ $t("accounts.accountNumber") }}</label>
            <p>{{ model.iban }}</p>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="4">
            <label class="second-type-label">{{ $t("accounts.description") }}</label>
            <p>{{ model.description }}</p>
          </v-col>
          <v-col :hidden="model.bic === ''" cols="12" sm="12" md="6" lg="4">
            <label class="second-type-label">{{ $t("accounts.bic") }}</label>
            <p>{{ model.bic }}</p>
          </v-col>
        </v-row>

        <v-row class="py-10">
          <v-col cols="12" sm="12" lg="12">
            <v-btn
              v-if="!confirmed"
              :style="`color: ${entityConfig.secondaryColor}`"
              @click="edit_account"
              depressed
              :color="entityConfig.primaryColor"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("supplierData.confirm") }}
            </v-btn>
            <v-btn
              v-else
              depressed
              @click="finalizar"
              :color="entityConfig.primaryColor"
              :style="`color: ${entityConfig.secondaryColor}`"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("supplierData.finish") }}
            </v-btn>

            <v-btn
              v-if="!confirmed"
              @click="$router.go(-1)"
              outlined
              :color="entityConfig.primaryColor"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("supplierData.goBack") }}
            </v-btn>

            <v-btn
              v-else
              plain
              @click="print"
              :color="entityConfig.primaryColor"
              class="float-end m-2 v-btn-width-default"
            >
              <v-icon left> mdi-printer-outline </v-icon>
              {{ $t("supplierData.print") }}
            </v-btn>
          </v-col>
          <v-col></v-col>
        </v-row>
        <overlay :visible="spinner" :opacity="1"></overlay>
      </v-container>
    </v-form>
  </layout-auth>
</template>

<script>
import LayoutAuth from "../../components/layouts/layout-auth.vue";

import Overlay from "../../components/layouts/overlay.vue";
import Api from "../../Services/index";

export default {
  components: {
    "layout-auth": LayoutAuth,
    Overlay,
  },
  data: () => ({
    userId: "",
    confirmed: false,
    userdata: {},
    form: {
      iban: "",
      description: "",
      bic: "",
    },

    spinner: false,
    checkbox: true,
    model: { iban: "", description: "", bic: "" },
    entityConfig: {},
  }),

  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
    Api.defaults.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("authtoken");
    this.userdata = JSON.parse(sessionStorage.getItem("userData"));
    this.userId = this.userdata.supplierId.trim();
    let editAccount = JSON.parse(sessionStorage.getItem("accountConfirmEdit"));
    if (editAccount) {
      this.model = editAccount;
      Api.defaults.headers.common["Authorization"] =
        "Bearer " + sessionStorage.getItem("authtoken");
    } else {
      this.$router.go(-1);
    }
  },

  methods: {
    print() {
      window.print();
    },

    async edit_account() {
      try {
        let message = "Su cuenta fue modificada de forma exitosa";
        this.spinner = true;
        const formData = new FormData();
        formData.append("iban", this.model.iban);
        formData.append("description", this.model.description);
        formData.append("bic", this.model.bic);

        Api.defaults.headers.common["Authorization"] =
          "Bearer " + sessionStorage.getItem("authtoken");
        const obj = Object.fromEntries(formData);
        await Api.put(`/proveedores/${this.userId}/cuentas-abono`, obj);
        this.spinner = false;
        this.confirmed = true;
        this.$toast.success(message);
        sessionStorage.removeItem("accountConfirmEdit");
      } catch (error) {
        this.$showError(this, error.response.data);
      } finally {
        this.spinner = false;
      }
    },
    finalizar() {
      this.$router.push({ path: "/cuentas-de-abono" });
    },
  },
};
</script>
